import { observer } from "mobx-react-lite";
import type FaultyCombinationsViewModel from "viewModels/users/accessRights/faultyCombinations/faultyCombinationsViewModel";
import FilterView from "../../../common/filter";
import Form from "react-bootstrap/Form";
import Col from "react-bootstrap/Col";
import { translateGeneral } from "utils/localizations";

import React from "react";
import AdvancedSelect from "@edaz/edazkit/controls/AdvancedSelect";

export interface FaultyCombinationsFiltersProps {
  vm: FaultyCombinationsViewModel;
}

const FaultyCombinationsFilters = observer((props: FaultyCombinationsFiltersProps) => {
  const { vm } = props;

  return (
    <FilterView vm={vm}>
      <div className="row">
        <Form.Group as={Col} md={8} lg={6} xl={6}>
          <Form.Label>{vm.translateAttribute("name")}</Form.Label>
          <AdvancedSelect
            target={vm.filter}
            property="areaId"
            placeholder={translateGeneral("search")}
            items={vm.areaOptions}
            allowEmpty={true}
          />
        </Form.Group>
      </div>
    </FilterView>
  );
});

export default FaultyCombinationsFilters;
